var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 64,
    viewBox: "0 0 104 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1464_16739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.666 43.3039L81.991 39.9289H74.449L73.249 43.2799L67.204 43.2919C71.09 33.9539 73.974 27.0369 75.856 22.5409C76.348 21.3649 77.221 20.7649 78.508 20.7739C79.492 20.7819 81.098 20.7829 83.326 20.7769L88 43.2949L82.666 43.3039ZM76.144 35.3059H81.007L79.192 26.8459L76.144 35.3059ZM37.186 20.7709L43.264 20.7769L33.868 43.3069L27.715 43.3009C26.1677 37.3498 24.6397 31.3938 23.131 25.4329C22.831 24.2449 22.237 23.4139 21.094 23.0209C20.072 22.6709 18.374 22.1299 16 21.3979V20.7769H25.711C27.391 20.7769 28.372 21.5899 28.687 23.2579C29.005 24.9299 29.805 29.1839 31.087 36.0199L37.186 20.7709ZM51.616 20.7769L46.813 43.3039L41.026 43.2949L45.82 20.7709L51.616 20.7769ZM63.346 20.3599C65.077 20.3599 67.258 20.8999 68.512 21.3979L67.498 26.0659C66.364 25.6099 64.498 24.9949 62.929 25.0159C60.649 25.0549 59.239 26.0119 59.239 26.9299C59.239 28.4239 61.687 29.1769 64.207 30.8089C67.081 32.6689 67.462 34.3399 67.426 36.1579C67.387 39.9229 64.207 43.6399 57.499 43.6399C54.439 43.5949 53.335 43.3399 50.839 42.4519L51.895 37.5799C54.436 38.6419 55.513 38.9809 57.685 38.9809C59.674 38.9809 61.381 38.1769 61.396 36.7759C61.408 35.7799 60.796 35.2849 58.564 34.0549C56.332 32.8249 53.2 31.1179 53.242 27.6889C53.293 23.3029 57.448 20.3599 63.346 20.3599Z",
    fill: "#A1A1A1"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 103,
    height: 63,
    rx: 4.5,
    stroke: "#313131"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1464_16739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 64,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.d61b686f36d6a7145e0fc19586399007.svg";
export { ForwardRef as ReactComponent };